import { render, staticRenderFns } from "./DiagnosticsSheet.vue?vue&type=template&id=4efc1355&scoped=true&"
import script from "./DiagnosticsSheet.vue?vue&type=script&lang=js&"
export * from "./DiagnosticsSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efc1355",
  null
  
)

export default component.exports